export class Job {
    // eslint-disable-next-line max-params
    constructor(
        readonly idJob: number,
        readonly idDGE: number,
        readonly dge: string,
        readonly documents: number,
        readonly pages: number,
        readonly formName: string,
        readonly started: string,
        readonly finished: string,
        readonly queueTime: number,
        readonly executionTime: number,
        readonly status: string,
        readonly tag1: string,
        readonly tag2: string,
        readonly tag3: string,
        readonly tag4: string,
        readonly tag5: string,
        readonly log: boolean,
        readonly relaunch: boolean,
        readonly transactions: string,
        readonly preview: string
    ) { }
}

export enum JobStatus {
    OK = 'OK',
    KO = 'KO',
    warning = 'warning'
}

export enum JobPreview {
    YES = 'Yes',
    NO = 'No'
}
export class JobConfiguration {
    // eslint-disable-next-line max-params
    constructor(
        readonly idJob: number,
        readonly idDGE: number,
        public format: string,
        readonly project: string,
        readonly output: string,
        readonly parameters: { name: string, value: string; }[]
    ) { }
}

export enum Format {
    Pdf = 'PDF',
    Afp = 'AFP',
    Pcl = 'PCL',
    Zpl = 'ZPL',
    Html = 'HTML',
    Txt = 'TXT',
    Rtf = 'RTF',
    Csv = 'CSV',
    Docx = 'DOCX',
    Emfz = 'EMFZ',
    Igp = 'IGP',
    Ipl = 'IPL',
    Pclxl = 'PCLXL',
    Ps = 'PS',
    custom = 'Custom Extension'
}       